import { createContext } from "react";


export const MultiCropContext = createContext();